
(function (angular) {

	angular.module('app', [
		'app.core'
	]);

})(angular);
